import React from 'react';
import PropTypes from 'prop-types';

import { Badge, P, H2, Link } from '@decisiv/ui-components';
import Envelope from '@decisiv/iconix/lib/components/Envelope';

import { InnerContainer } from './styledComponents';

function Success({ email }) {
  return (
    <InnerContainer>
      <Badge
        aria-label="envelope badge"
        color="success"
        icon={Envelope}
        size="large"
        palette="bright"
      />
      <H2
        style={{
          textAlign: 'center',
          margin: '20px 0 0',
          padding: '0',
        }}
      >
        Your Account has Been Created
      </H2>
      <P
        fontWeight={500}
        shade={1}
        style={{
          textAlign: 'center',
          marginBottom: '20px',
        }}
      >
        We’ve sent a confirmation email to{' '}
        <span style={{ fontWeight: '600' }}>{email}</span>.
        <br />
        Please check your inbox and click the confirmation link to complete your
        registration.
        <br />
        If you don’t see the email, check your spam or junk folder.
      </P>
      <div>
        <Link to="/login" text="Go to Log In" />
      </div>
    </InnerContainer>
  );
}

Success.propTypes = {
  email: PropTypes.string.isRequired,
};

export default Success;
